import SiteHeader from "./components/SiteHeader";
import Hero from "./components/Hero";
import NovelIntro from "./components/NovelIntro";
import ReadingEntries from "./components/ReadingEntries";
import ChapterList from "./components/ChapterList";
import ReaderReviews from "./components/ReaderReviews";
import FaqSection from "./components/FaqSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body">
      <SiteHeader />
      <main>
        <Hero />
        <NovelIntro />
        <ReadingEntries />
        <ChapterList />
        <ReaderReviews />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}